module.exports = ":host {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  position: relative;\n  padding-right: 20px;\n  padding-bottom: 12px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pillar/workspace/components/metadata-form-control/metadata-form-control.component.scss
// module id = ./src/app/pillar/workspace/components/metadata-form-control/metadata-form-control.component.scss
// module chunks = main